(() => {
  const bundleHandle = '30-day-complete-vitiligo-care-bundle-luminaderm';
  const subscribePrice = '$95.24';
  const oneTimePrice = '$126.99';
  const subscribeLabel = `START MY MONTHLY ROUTINE - ${subscribePrice}/MONTH`;
  const oneTimeLabel = `BUY ONCE - ${oneTimePrice}`;

  function isBundlePage() {
    return (window.location.pathname || '').includes(bundleHandle) ||
      /30-Day Complete Vitiligo Care Bundle LuminaDerm/i.test(document.querySelector('h1')?.textContent || '');
  }

  function getMode() {
    const productPanel = document.querySelector('.ld-product-panel');
    const activeOption = productPanel?.querySelector('[data-option].is-active, [data-ld-final-option].is-active');
    const activeValue = activeOption?.getAttribute('data-option') || activeOption?.getAttribute('data-ld-final-option') || '';
    if (activeValue === 'onetime') return 'onetime';
    if (activeValue === '3tube' || activeValue === 'subscription') return 'subscription';

    const checked = document.querySelector('input[type="radio"]:checked');
    const text = checked?.closest('label, div')?.textContent || '';
    if (/One-time purchase/i.test(text)) return 'onetime';
    if (/Subscribe and save/i.test(text)) return 'subscription';
    return 'subscription';
  }

  function replaceTextIn(selector, from, to) {
    document.querySelectorAll(selector).forEach((container) => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.nodeValue && node.nodeValue.includes(from)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        },
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        node.nodeValue = node.nodeValue.split(from).join(to);
      });
    });
  }

  function replaceText(from, to) {
    document.querySelectorAll('body *').forEach((el) => {
      if (el.children.length || !el.textContent.includes(from)) return;
      el.textContent = el.textContent.split(from).join(to);
    });
  }

  function hideCheckoutReassuranceLines() {
    const lines = ['You Get Free Shipping!', '30-Day Risk-Free Money-Back Guarantee'];
    document.querySelectorAll('.ld-product-panel .ld-checkline').forEach((line) => {
      const text = (line.textContent || '').replace(/\s+/g, ' ').trim();
      if (lines.includes(text)) line.style.setProperty('display', 'none', 'important');
    });
  }

  function hideQuantitySelector() {
    document.querySelectorAll('select').forEach((select) => {
      if ((select.textContent || '').trim() !== 'Bundle') return;
      const box = select.closest('label, div');
      if (!/One-time purchase/i.test(box?.textContent || '')) return;
      if (select.parentElement) select.parentElement.style.display = 'none';
    });
  }

  function isDarkGreenBackground(element) {
    const match = getComputedStyle(element).backgroundColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/i);
    if (!match) return false;
    const r = Number(match[1]);
    const g = Number(match[2]);
    const b = Number(match[3]);
    const alpha = match[4] === undefined ? 1 : Number(match[4]);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return alpha > 0 && g >= r && g >= b && brightness < 145;
  }

  function findNearestDarkCard(element) {
    let current = element;
    for (let i = 0; current && i < 5; i += 1) {
      const rect = current.getBoundingClientRect();
      const isLeftSide = rect.left < window.innerWidth * 0.55;
      const isCardSize = rect.width >= 220 && rect.width <= 520 && rect.height >= 180 && rect.height <= 420;
      if (isLeftSide && isCardSize && isDarkGreenBackground(current)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function makeLeftDarkBenefitsCardWhite() {
    document.querySelectorAll('.ld-benefit-tile h1, .ld-benefit-tile h2, .ld-benefit-tile h3').forEach((heading) => {
      if ((heading.textContent || '').trim() !== 'Subscription Benefits') return;
      const card = findNearestDarkCard(heading);
      if (!card) return;
      card.style.setProperty('color', '#ffffff', 'important');
      card.querySelectorAll('h1, h2, h3, h4, p, li, span, div').forEach((el) => {
        el.style.setProperty('color', '#ffffff', 'important');
      });
      card.querySelectorAll('svg, svg *').forEach((el) => {
        el.style.setProperty('color', '#ffffff', 'important');
        el.style.setProperty('stroke', '#ffffff', 'important');
      });
    });
  }

  function syncButton(preferredFinalMode) {
    document.querySelectorAll('.ld-product-panel .ld-add, [data-ld-final-add]').forEach((button) => {
      let mode = getMode();

      if (button.matches('[data-ld-final-add]')) {
        const section = button.closest('[data-luminaderm-section]');
        let activeValue = preferredFinalMode || '';
        if (activeValue !== 'onetime' && activeValue !== 'subscription') {
          const activeOption = section?.querySelector(
            '[data-ld-final-option].is-active, [data-ld-final-option][aria-pressed="true"]'
          );
          activeValue = activeOption?.getAttribute('data-ld-final-option') || '';
        }
        if (activeValue === 'onetime' || activeValue === 'subscription') mode = activeValue;
      }

      const label = mode === 'onetime' ? oneTimeLabel : subscribeLabel;
      if (button.textContent.trim() !== label) button.textContent = label;
    });
  }

  function sync(preferredFinalMode) {
    if (!isBundlePage()) return;
    replaceTextIn('.ld-benefit-tile, .ld-panel-benefits', 'Save Up To 33% Off', 'Save Up To 25% Off');
    replaceText('$74.99', subscribePrice);
    replaceText('$99.99', oneTimePrice);
    hideCheckoutReassuranceLines();
    hideQuantitySelector();
    makeLeftDarkBenefitsCardWhite();
    syncButton(preferredFinalMode);
  }

  function scheduleSync(event) {
    const clickedOption = event?.target instanceof Element
      ? event.target.closest('[data-ld-final-option]')
      : null;
    const clickedMode = clickedOption?.getAttribute('data-ld-final-option') || '';
    const preferredFinalMode =
      clickedMode === 'onetime' || clickedMode === 'subscription' ? clickedMode : '';

    window.requestAnimationFrame(() => sync(preferredFinalMode));
    window.setTimeout(() => sync(preferredFinalMode), 80);
    window.setTimeout(() => sync(preferredFinalMode), 350);
  }

  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('click', scheduleSync, true);
  document.addEventListener('shopify:section:load', scheduleSync);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync);
  else scheduleSync();
})();
